import ComingSoon from "@/components/ComingSoon";

export default function LogsPage() {
  return <ComingSoon featureName="Audit Logs" description="Query and filter audit logs, device logs, and AI-analyzed events. This feature requires backend Audit Logs APIs." />;
}
